import { api } from "./../../config/api";
import { toFormData, toQueryString } from "../../helpers/form";

const basePath = "manutencao-banco-hora";

/**
 * Create
 *
 * @param {Object} options
 *
 * @returns {Promise<T>}
 */
export const create = (options) => {
	return api.post(basePath, options);
};

/**
 * Get current balance
 *
 * @param {Object} params
 *
 * @returns {Promise<T>}
 */
export const getCurrentBalance = (params) => {
	return api.get(`${basePath}/saldo-atual`, { params });
};
/**
 * Preview
 *
 * @param {Object} params
 *
 * @returns {Promise<T>}
 */
export const getPreview = (params) => {
	return api.get(`${basePath}/previa`, params);
};
